import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RegWallContainer } from '@surfline/quiver-react';
import { TABLET_LARGE_WIDTH, trackEvent } from '@surfline/web-common';
import { getShowForm } from '../../../../selectors/navigation';
import SignIn from '../SignIn';
import LearnMore from '../LearnMore';
import Home from '../Home';
import { showForm as navigate } from '../../../../actions/navigation';
import {
  SIGN_IN,
  LEARN_MORE,
  HOME,
  SERVED_POPUP,
  FORCED_REGISTRATION,
} from '../../../../common/constants';

const trackPopupServed = () =>
  trackEvent(SERVED_POPUP, {
    popupName: FORCED_REGISTRATION,
    category: FORCED_REGISTRATION,
    platform: 'web',
    isMobileView: window.innerWidth <= TABLET_LARGE_WIDTH,
  });

/**
 * @function MeterBottomSheetRegWall
 * @param {object} props
 * @return {JSX.Elemet}
 */
const MeterBottomSheetRegWall = () => {
  useEffect(() => {
    trackPopupServed();
  }, []);

  const showForm = useSelector(getShowForm);
  const dispatch = useDispatch();
  const handleNavigation = (goto) => dispatch(navigate(goto));
  const renderForm = () => {
    switch (showForm) {
      case SIGN_IN:
        return <SignIn />;
      case LEARN_MORE:
        return <LearnMore />;
      default:
        return <Home />;
    }
  };
  return (
    <div className="sl-meter-bottom-sheet">
      <RegWallContainer>
        <div className="sl-meter-bottom-sheet__modal">
          {showForm === HOME ? null : (
            <button
              className="sl-meter-bottom-sheet__modal__action__back"
              onClick={() => handleNavigation(HOME)}
              type="button"
            >
              <div className="sl-meter-bottom-sheet__modal__action__arrow" />
              <span>BACK</span>
            </button>
          )}
          {renderForm()}
        </div>
      </RegWallContainer>
    </div>
  );
};

export default MeterBottomSheetRegWall;
